import React from 'react';
import {
  AfterSubmitFunc,
  FormTemplate,
  SubmitButton,
  Text,
} from 'ui-builder';
import {
  useClientAppAccessService,
} from 'nekst-api';
import { ContactsCheckboxGroup } from 'features/nekst-widgets';
import { useDataLoaderNew } from 'data-loader';
import { toastService } from '../../shared/toasts/toastService';

interface ShareClientPortalPopupProps {
  projectId: number;
  afterSubmitFunc?: AfterSubmitFunc;
}

interface ShareClientPortalFormData {
  personIds: number[];
}

function ShareClientPortalForm(props: { projectId: number }) {
  return (
    <>
      <Text>
        The following users will receive a notification that this Client Portal
        is now available in their Nekst Client mobile app.
      </Text>
      <ContactsCheckboxGroup
        projectId={props.projectId}
        source="personIds"
        hideLabel
      />
    </>
  );
}

export default function ShareClientPortalPopup(props: ShareClientPortalPopupProps) {
  const clientAppAccessService = useClientAppAccessService();

  const { data, loading } = useDataLoaderNew<number[]>(
    async () => {
      return clientAppAccessService.getAccessPersonIds(props.projectId);
    },
    {
      dependencies: [props.projectId],
    },
  );

  const handleSubmit = async (formData: ShareClientPortalFormData): Promise<ShareClientPortalFormData> => {
    await clientAppAccessService.setAccess(props.projectId, formData.personIds || []);
    toastService.createToast('Portal access updated successfully');
    return formData;
  };

  if (loading || data === undefined) {
    return null;
  }

  return (
    <FormTemplate<ShareClientPortalFormData>
      title="Share Portal with Transaction Party"
      submitFormFunc={handleSubmit}
      afterSubmitFunc={props.afterSubmitFunc}
      buttons={<SubmitButton text="Save" testId="save-share-portal" />}
      initialData={{ personIds: data }}
    >
      <ShareClientPortalForm projectId={props.projectId} />
    </FormTemplate>
  );
}
